import { render } from "./SelectProductType.vue?vue&type=template&id=39d46f09"
import script from "./SelectProductType.vue?vue&type=script&lang=js"
export * from "./SelectProductType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__